import type { CSSProperties } from 'react';

import classNames from 'classnames';
import Prism from 'prismjs';

import { getWidthStyle } from '../utils/sizing';

import * as styles from './CodeBlock.css';
import type { CodeBlockElementProps } from './CodeBlock.type';
import 'prismjs/themes/prism-okaidia.css';

import { CODE_BLOCK_DEFAULTS } from './CodeBlock.constants';

export function CodeBlockElement(props: CodeBlockElementProps) {
  const { element, className, attributes } = props;
  const { width, width_max, mobile_hide, desktop_hide, customAttributes, margin, border_radius, box_shadow, language } =
    element.attrs || {};

  const { content } = element;

  const highlightedCode = Prism.highlight(
    content[0].text,
    Prism.languages[language || 'javascript'],
    language || 'javascript',
  );

  const [marginTop, marginRight, marginBottom, marginLeft] = (margin ?? CODE_BLOCK_DEFAULTS.margin)
    .toString()
    .split(' ');

  return (
    <div
      {...customAttributes}
      className={classNames(
        className,
        {
          'mobile:hidden': mobile_hide,
          'desktop:hidden': desktop_hide,
        },
        styles.codeBlockElement,
        customAttributes?.className,
      )}
      style={
        {
          '--width': getWidthStyle(width, width_max).width,
          '--max-width': getWidthStyle(width, width_max).maxWidth,
          '--margin-top': marginTop,
          '--margin-right': marginRight,
          '--margin-bottom': marginBottom,
          '--margin-left': marginLeft,
          '--margin': margin ?? CODE_BLOCK_DEFAULTS.margin,
          '--border-radius': border_radius ?? CODE_BLOCK_DEFAULTS.borderRadius,
          '--box-shadow': box_shadow ?? CODE_BLOCK_DEFAULTS.boxShadow,
        } as CSSProperties
      }
      {...attributes}
    >
      <pre className={`language-${language}`}>
        <code className={`language-${language}`} dangerouslySetInnerHTML={{ __html: highlightedCode }} />
      </pre>
    </div>
  );
}
